// eslint-disable-next-line no-unused-vars
import { Action } from "../../../personal-studio-components/frame";
// eslint-disable-next-line no-unused-vars
import { SchemaJSON } from "../../../personal-studio-components/form";
// eslint-disable-next-line no-unused-vars
import { TableModel } from "../../../personal-studio-components/table";
export { BringFriendModel };
/** 
 * Модель страницы "Акции / Пригласить друга".
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
class BringFriendModel {
  /**
   * Заголовок виджета.
   * @type {string}
   */
  title = "Приведи друга";
  /**
   * Иконка виджета.
   * @type {string}
   */
  icon = "friends";
  /**
   * Текст приглашения в формате HTML.
   * @type {string}
   */
  text;
  /**
   * Модель таблицы.
   * @type {TableModel}
   */
  table;
  /**
   * Состояние диалога: открыт (true) | закрыт (false).
   * @type {boolean}
   */
  open = false;
  /**
   * Переменные окружения, подставляемые в каждый запрос.
   * @type {Object}
   */
  env = {};
  /**
   * Открывает/закрывает диалог.
   * @param {Event | Object} event - Событие.
   */
  onClick = event => { };
  /**
   * Отправляет запрос на добавление друга.
   * @param {Object} data - Данные формы.
   */
  onSubmit = data => { };
  /**
   * @returns {Array.<Action>} Меню виджета.
   */
  getMenu = () =>
    [
      {
        name: "Пригласить друга",
        icon: "new_file",
        href: "#open",
        onClick: this.onClick,
      },
    ];
  /**
   * @returns {Request} Запрос на загрузку таблицы.
   */
  getRequest = () =>
  ({
    method: "post",
    path: "/student/bring_friend/list",
    data: {
      ...this.env
    },
  });
  /**
   * @returns {Request} Запрос на добавление друга.
   * @param {Object} data - Данные формы.
   */
  getSubmitRequest = data =>
  ({
    method: "post",
    path: "/student/bring_friend/add",
    data: {
      ...this.env,
      ...data,
    },
  });
  /**
   * @returns {SchemaJSON} Схема формы для диалога добавления друга.
   */
  getSchema = () =>
  ({
    title: "Пригласить друга",
    properties: {
      name: {
        title: "Имя",
        type: "string",
      },
      email: {
        title: "E-mail",
        type: "string",
        format: "email",
      },
      mobile_phone: {
        title: "Телефон",
        type: "string",
        pattern: "^[\\s0-9()*#+-]+$",
      },
      education_kind_desc: {
        title: "Вид интересующего образования",
        type: "string",
        style: "new_line",
        default: "",
      },
      direction_desc: {
        title: "Направление специальности",
        type: "string",
        default: "",
      },
    },
    required: ["name", "email", "mobile_phone"],
    actions: [
      {
        name: "Пригласить друга",
        type: "primary",
      },
      {
        name: "Отмена",
        onClick: this.onClick,
      },
    ],
    onSubmit: this.onSubmit,
  });
  /**
   * Разбор ответа от сервера.
   * @param {Object} response - Ответ от сервера. 
   */
  parseResponse(response) {
    this.text = response.text;
    this.table = response;
  }
  /**
   * Копирует свойства объекта.
   * @param {BringFriendModel} props - Свойства объекта.
   */
  constructor(props) { Object.assign(this, props); }
}